import { Typography } from "@mui/material";
import React from "react";

const SectionTitle = ({title,mandatory=false}) => {
  return (
    <>
      <Typography  variant="subtitle1">{title}{mandatory && <Typography component={"span"} color={"error"}>
            *
          </Typography>}</Typography>
   
    </>
  );
};

export default SectionTitle;
